export default "/images/vendor/flag-icon-css/flags/1x1/mf.svg?c02a78fb2738ceb5eece24c60cb245f5";